import React from 'react';
import {Document as PDFDocument, Page, View} from '@react-pdf/renderer';
import BWResumeHeader from 'src/components/Resume/bw-resume-header';
import formatStudentForResume from 'src/components/Resume/format-student-for-resume';
import ResumeHeader from 'src/components/Resume/resume-header';
import {registerWebFonts, createResumePageStyles} from 'src/components/Resume/styles';
import PrintResumeSections from 'src/components/Resume/print-resume-sections';
import {Student} from 'src/types/store';

interface Props {
  student: Student;
  blackAndWhite?: boolean;
}

const PrintResumeDocument = ({student, blackAndWhite}: Props) => {
  registerWebFonts();

  const formattedStudent = formatStudentForResume(student);
  const styles = createResumePageStyles();

  return (
    <PDFDocument>
      <Page>
        {!blackAndWhite && <ResumeHeader studentInfo={formattedStudent} />}
        <View style={styles.pageContainer}>
          {blackAndWhite && <BWResumeHeader studentInfo={formattedStudent} />}
          <PrintResumeSections studentInfo={formattedStudent} blackAndWhite={blackAndWhite} />
        </View>
      </Page>
    </PDFDocument>
  );
};

export default PrintResumeDocument;
